import { compose } from 'redux';

let allMiddlewares = [];

export const dynamicMiddleware = store => {
  return next => action => {
    return compose(...allMiddlewares.map(middleware => middleware(store)))(
      next
    )(action);
  };
};

export const addMiddleware = (...middleware) => {
  allMiddlewares.push(...middleware);
};

export const removeMiddleware = middleware => {
  allMiddlewares = allMiddlewares.filter(m => m !== middleware);
};

export const resetMiddlewares = () => {
  allMiddlewares = [];
};

export const hasMiddlewareExisted = middleware => {
  return allMiddlewares.includes(middleware);
};
